import GlobalOverlay from './GlobalOverlay'

export default GlobalOverlay
